<script setup lang="ts">
  import { computed, onMounted } from 'vue'
  import { useRoute } from 'vue-router'
  import { useAuthStore } from '@/stores/auth'
  import Toast from 'primevue/toast'
  import ConfirmDialog from 'primevue/confirmdialog'
  import DynamicDialog from 'primevue/dynamicdialog'
  import ProgressSpinner from 'primevue/progressspinner'
  import TwoFactorEnforcementDialog from '@/components/TwoFactorEnforcementDialog.vue'

  const authStore = useAuthStore()
  const route = useRoute()

  // Remount the active view when the organization changes so org-scoped data
  // reloads - EXCEPT during onboarding, where the wizard itself creates and
  // switches to the new org; a remount there resets the wizard to step 1.
  const routerViewKey = computed(() =>
    route.name === 'onboarding'
      ? 'onboarding'
      : (authStore.currentOrganization?.id ?? 'no-org')
  )

  onMounted(async () => {
    // Check if user is already authenticated on app load
    await authStore.checkAuth()
  })
</script>

<template>
  <Toast position="top-right" />
  <ConfirmDialog />
  <DynamicDialog />
  <TwoFactorEnforcementDialog />

  <!-- Loading state while checking authentication -->
  <div v-if="!authStore.isInitialized" class="app-loading">
    <div class="loading-content">
      <ProgressSpinner strokeWidth="4" />
      <p class="loading-text">Loading...</p>
    </div>
  </div>

  <!-- Main app content -->
  <template v-else>
    <RouterView :key="routerViewKey" />
  </template>
</template>

<style>
  /* Global styles can go here or in main.css */

  .app-loading {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fafafa;
    z-index: 9999;
  }

  .loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .loading-text {
    color: rgba(0, 0, 0, 0.6);
    font-size: 1rem;
    margin: 0;
  }
</style>
